import { render, staticRenderFns } from "./invoices-modal.vue?vue&type=template&id=7b6209eb&"
import script from "./invoices-modal.vue?vue&type=script&lang=js&"
export * from "./invoices-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports